import { render, staticRenderFns } from "./ModelCreator.vue?vue&type=template&id=08b86602&scoped=true"
import script from "./ModelCreator.vue?vue&type=script&lang=js"
export * from "./ModelCreator.vue?vue&type=script&lang=js"
import style0 from "./ModelCreator.vue?vue&type=style&index=0&id=08b86602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b86602",
  null
  
)

export default component.exports